module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "subtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('em', [_vm._v("An Album of Union Soldiers and Their Stories")])]), _vm._v(" "), _c('h1', {
    staticClass: "h1",
    attrs: {
      "id": "ch00_fm03"
    }
  }, [_vm._v("Faces of the Civil War")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONALD")]), _vm._v(" S. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODDINGTON")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITH A")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OREWORD BY")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICHAEL")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELLMAN")])]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pub.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3212f3f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm03.vue
// module id = 66
// module chunks = 0